var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-0{fill:none;}\n            .cls-1{fill:#fff;}\n            .cls-2{fill:#efeff0;}\n            .cls-3{fill:#d2ddfa;}\n            .cls-4{fill:#b4c6fa;}\n            .cls-5{fill:#4a77f6;}\n            .cls-6{fill:#668fff;}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M12,1A6.46,6.46,0,0,0,5.53,7.44a8.17,8.17,0,0,0,2.26,5.17L17,3.4A6.45,6.45,0,0,0,12,1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M12,15c2.78,0,6.47-4,6.47-7.52A6.39,6.39,0,0,0,17,3.4L7.79,12.61A6.31,6.31,0,0,0,12,15Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M21.84,20.23l-2-4.63,0-.11-.06-.12a2,2,0,0,0-2.68-.89L14.5,16a5.39,5.39,0,0,1-.48.25,4.91,4.91,0,0,1-4,0c-.16-.08-.33-.16-.48-.25L6.9,14.48l-.12-.06a1.91,1.91,0,0,0-.67-.14,2,2,0,0,0-1.95,1.21l-2,4.74A1.91,1.91,0,0,0,2,21a2,2,0,0,0,2,2H20a1.87,1.87,0,0,0,.77-.16A2,2,0,0,0,21.84,20.23Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLight);
export default __webpack_public_path__ + "static/media/user-light.b823f6ecb2763d1bc7f636c81f25236b.svg";
export { ForwardRef as ReactComponent };